<template>
  <div class="container-fluid h-100 reservation-create__container">
    <div class="col-md-12 py-5 h-100">
      <div class="row py-5 justify-content-center d-flex h-100 align-items-center">
        <div class="col-md-10">
          <FormulateForm
            v-model="formValues"
            v-if="formValues"
            @submit="submitInfo"
          >
          <div class="card">
            <div class="card-header">
              <h5 class="card-title">Reserveer uw plek</h5>
            </div>
            <div class="card-body">
              <div class="container p-0">
                <div class="date mb-1">
                  <div class="row col-md-12">
                    <div class="col-md-6 leftside">
                      <p class="font-weight-bold w-100 mb-1">Vluchtinformatie</p>
                      <div class="formulate-input">
                        <div class="formulate-input-wrapper mb-2 col-md-12">
                          <label class="formulate-input-label formulate-input-label--before">
                            Datum
                          </label>
                          <v-date-picker
                            v-model="date"
                            mode='range'
                            :masks="{ input: ['DD-MM-YYYY'], data: ['DD-MM-YYYY']}"
                            :input-props='{
                              style:"max-width: 18.5em;"
                            }'
                            class="formulate-input-element formulate-input-element--text"
                            :is-required="true"
                          ></v-date-picker>
                        </div>
                        <div class="row mb-2">
                          <div class="col-md-12 d-flex">
                            <div class="formulate-input col-md-6 mb-2">
                              <div class="formulate-input-wrapper">
                                <label class="formulate-input-label formulate-input-label--before">
                                  Aflevertijd
                                </label>
                                <vue-timepicker
                                  v-model="dropoffTime"
                                  hour-label=" "
                                  minute-label=" "
                                  minute-interval="5"
                                  hide-clear-button
                                  input-class="w-100"
                                  class="formulate-input-element formulate-input-element--text w-100"
                                ></vue-timepicker>
                              </div>
                            </div>
                            <div class="formulate-input col-md-6 mb-0">
                              <div class="formulate-input-wrapper">
                                <label class="formulate-input-label formulate-input-label--before">
                                  Ophaaltijd
                                </label>
                                <vue-timepicker
                                  v-model="pickupTime"
                                  hour-label=" "
                                  minute-label=" "
                                  minute-interval="5"
                                  hide-clear-button
                                  input-class="w-100"
                                  class="formulate-input-element formulate-input-element--text w-100"
                                ></vue-timepicker>
                              </div>
                            </div>
                            <div class="col-md-6 d-flex">
                              
                            </div>
                          </div>
                          <div class="col-md-12 d-flex">
                            <div class="col-md-6">
                          <FormulateInput
                        type="text"
                        name="departureFlight"
                        label="Vluchtnummer Vertrek"
                        placeholder="KL0101"
                        validation="required"
                      />
                        </div>
                        <div class="col-md-6">
                      <FormulateInput
                        type="text"
                        name="arrivalFlight"
                        label="Vluchtnummer Aankomst"
                        placeholder="KL0101"
                        validation="required"
                      />  
                        </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                        <p class="font-weight-bold w-100 mb-1">Voertuiginformatie</p>
                        <div class="col-md-12">
                          <FormulateInput
                          type="text"
                          v-model="licensePlate"
                          name="license_plate"
                          label="Kenteken"
                          placeholder="Kenteken"
                          validation="required"
                          class="mb-2"
                        />
                        <FormulateInput
                          type="text"
                          name="make_model"
                          label="Merk & Model"
                          :placeholder="`Bijv. ${this.randomCarPlaceholder[this.randomCarPlaceholderIndex]}`"
                          validation="required"
                          class="mb-2"
                        />
                        <FormulateInput
                          type="text"
                          name="vehicle_color"
                          label="Kleur"
                          placeholder="Grijs"
                          validation="required"
                          class="mb-2"
                        />
                        </div>
                      </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 rightside">
                      <div class="col-md-12">
                        <p class="font-weight-bold w-100 mb-1">Hoe kunnen we u bereiken?</p>
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-6">
                              <FormulateInput
                                type="text"
                                name="firstName"
                                label="Voornaam"
                                validation="required"
                                tabindex="1"
                                autocomplete="given-name"
                              />
                            </div>
                            <div class="col-md-6">
                              <FormulateInput
                                type="text"
                                name="lastName"
                                label="Achternaam"
                                validation="required"
                                tabindex="2"
                                autocomplete="family-name"
                              />
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-md-6">
                              <FormulateInput
                                type="email"
                                name="email"
                                label="Email"
                                validation="required"
                                tabindex="3"
                                autocomplete="email"
                              />
                            </div>
                            <div class="col-md-6">
                              <FormulateInput
                                type="tel"
                                name="phone"
                                label="Telefoonnummer"
                                validation="required"
                                tabindex="4"
                                autocomplete="tel"
                              />
                            </div>
                          </div>
                          <div class="row my-3">
                            <div class="col-md-12">
                              <FormulateInput
                                label="Extra Email"
                                type="checkbox"
                                name="otherPaymentMethods"
                                v-model="enableExtraEmail"
                              />
                            </div>
                            <div class="col-md-12" v-if="enableExtraEmail">
                              <FormulateInput
                                type="email"
                                name="extra_email"
                                label="Extra email"
                                tabindex="3"
                              />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <FormulateInput
                                type="textarea"
                                name="comment"
                                placeholder="Bijv. Gelieve de stoel niet verzetten."
                                label="Opmerkingen factuur"
                                class="mb-2"
                              />
                              <FormulateInput
                                type="textarea"
                                name="driver_comment"
                                placeholder="Bijv. Gelieve de stoel niet verzetten."
                                label="Opmerkingen voor de chauffeur"
                                class="mb-2"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <p class="font-weight-bold w-100 mb-1">Services</p>
                        <div class="col-md-12">
                          <FormulateInput
                          name="carwash"
                          :options="carwashList"
                          type="select"
                          value="0"
                          label="Carwash"
                          class="mb-2"
                        />
                        <FormulateInput
                          name="elektrisch"
                          :options="elektrischeServices"
                          type="select"
                          value="0"
                          label="Elektrisch opladen?"
                          class="mb-2"
                        />
                        <FormulateInput
                          v-for="(service, index) in algemeneServices"
                          :name="`service_id-${index}`"
                          type="checkbox"
                          :label="service"

                          class="mb-0"
                          :key="`algemeen-${service}`"
                        />

                        
                        </div>
                      </div>
                    </div>
                  </div>
                 </div>
              </div>
            </div>
            <div class="card-footer d-flex justify-content-end text-muted align-items-center">
              <p class="mb-0 font-weight-bold mx-3">
                {{price | currency}}
              </p>
              <FormulateInput
                type="submit"
                class="btn btn-primary btn-formulate-submit"
                label="Volgende"
              />
            </div>
          </div>

          </FormulateForm>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _debounce from 'lodash/fp/debounce';

  export default {
      computed: {
          reservation: {
              get: function () {
                  return this.$store.state.reservation
              },
              // setter
              set: function (newValue) {
                  this.fetchPrice();
              }
          },
          date: {
              get: function () {
                  return this.$store.state.reservation.date
              },
              // setter
              set: function (newValue) {
                  this.$store.commit('reservation/addDate', newValue)
                  this.fetchPrice();
              }
          },
          licensePlate: {
              get: function () {
                  return this.$store.state.reservation.info.license_plate
              },
              // setter
              set: function (newValue) {
                  this.$store.commit('reservation/addVehicleInfo', {license_plate: newValue})
              }
          },
          formValues: {
              get: function () {
                  return this.$store.state.reservation.info
              },
              // setter
              set: function (newValue) {
                  this.$store.commit('reservation/add', newValue);
                  this.fetchPrice();
              }
          },
          dropoffTime: {
              get: function () {
                  return this.$store.state.reservation.dropoffTime
              },
              // setter
              set: function (newValue) {
                  this.$store.commit('reservation/addDropoffTime', newValue)
              }
          },
          pickupTime: {
              get: function () {
                  return this.$store.state.reservation.pickupTime
              },
              // setter
              set: function (newValue) {
                  this.$store.commit('reservation/addPickupTime', newValue)
              }
          }
      },
      watch: {
          licensePlate(){
              this.getLicenseplate()
          },
      },
      data() {
          return {
              price: undefined,
              carwashList: [],
              elektrischeServices: [],
              algemeneServices: [],
              enableExtraEmail: false,
              randomCarPlaceholder: [
                  'BMW 1-serie',
                  'Peugeot 508',
                  'Tesla Model S',
                  'Toyota Prius',
                  'Skoda Fabia',
                  'Opel Corsa'
              ],
              randomCarPlaceholderIndex: Math.floor(Math.random() * 6)
          }
      },
      beforeMount(){
          this.$axios.get('reservations/services?type=algemeen').then(response => {
              this.algemeneServices = response.data;
          });
          this.$axios.get('reservations/services?type=carwash', {params: {withEmptyPlaceholder: true}}).then(response => {
              this.carwashList = response.data;
          });
          this.$axios.get('reservations/services?type=elektrisch', {params: {withEmptyPlaceholder: true}}).then(response => {
              this.elektrischeServices = response.data;
          });
          if(!this.date.start && !this.date.end){
              this.$store.commit('reservation/addDate', {
                  start: this.$moment().toDate(), // Jan 16th, 2018
                  end: this.$moment().add(8, 'days').toDate()    // Jan 19th, 2018
              })
          }
      },
      mounted(){
          this.fetchPrice();
      },
      methods: {
          submitInfo() {
              this.$router.push({ name: 'reservation-create-personal' })
          },
          fetchPrice(){
              let fullReservation = JSON.parse(JSON.stringify(this.reservation));
              fullReservation.date.start = `${this.$moment(fullReservation.date.start).format('YYYY-MM-DD')} ${fullReservation.dropoffTime}:00`;
              fullReservation.date.end = `${this.$moment(fullReservation.date.end).format('YYYY-MM-DD')} ${fullReservation.pickupTime}:00`;
              this.$axios.post('/reservations/price', {
                  ...fullReservation
              }).then((response)=>{
                  this.price = response.data.price
              })
          },
          getLicenseplate: _debounce(500, function(){
              this.$axios.get('reservations/license-plate', {
                  params: {
                      kenteken: this.licensePlate.replace(/[^a-zA-Z0-9]/g,'').toUpperCase()
                  }}).then(response => {
                  if(response.data.length > 0){
                      this.$store.commit('reservation/addVehicleInfo', {
                          make_model: `${response.data[0].merk} ${response.data[0].handelsbenaming}`,
                          vehicle_color: response.data[0].eerste_kleur
                      })
                  }
              })
          })
      }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

  .reservation-create__container{
    background-size: cover;
    background-position: center;
    // background-image: url('~assets/img/schiphol.jpg')
  }
  .mw-20em{
    width: 100%;
    max-width: 20em !important;
  }
  .card{
    h5{
      font-weight: 500;
    }
    .btn{
      font-weight: 500;
      font-family: 'Work Sans', sans-serif;
      .formulate-input-element--submit{
        button{
          padding: 0;
          font-weight: 500;
          font-family: 'Work Sans', sans-serif;
        }
      }
    }
  }
  .btn-formulate-submit{
    padding: 0;
    border: none;
    .formulate-input-element.formulate-input-element--submit{
      margin-bottom: 0;
      button{
        border: none;
        background-color: #1b55e3;
        &:hover{
          background-color: #3d6fe7;
        }
      }
    }
      .formulate-input-element--submit--label{
        padding: 10px 12px;
      }
  }
  .leftside{
    border-right: 1px solid #1b55e3;
  }
</style>
